import { Component } from '@angular/core';
import { TraceServiceImprovement } from '../core/services/trace-improvement.service';
import { I18nService } from 'i18n/i18n.service';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DetailComponent } from './detail/detail.component';
import { finalize } from 'rxjs/operators';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-trace-viewer-management',
  templateUrl: './trace-viewer-management.component.html',
  styleUrls: ['./trace-viewer-management.component.scss']
})
export class TraceViewerManagementComponent {
  public traces: any = [];
  public selectedTraces: Array<IBATraceFile> = [];

  public traceFilter: ITraceFilterManagement = null;

  public showLoading: boolean = false;
  public isCollapsed: boolean = false;
  public isDownloading: boolean = false;
  public isDeleting: boolean = false;
  public exceedsResultLimit: boolean = false;

  public loadingMessage: string = '';

  constructor(private _traceService: TraceServiceImprovement, private _i18nService: I18nService, 
    private _toastService: BzgToastService, private _modalService: BzgModalService, 
    private _showToastService: ShowToastService) {
  }

  getFilesNames(traceFilter: ITraceFilterManagement, reload: boolean = true) {
    if (reload) {
      this.traces = [];
      this.showLoading = true;
    }
    this.traceFilter = traceFilter;
    this.loadingMessage = this._i18nService.instant('TRACE.LOADING_FILES');
    this._traceService.getFileNames(this.traceFilter).subscribe((data: any) => {
      this.exceedsResultLimit = data.exceedsResultLimit;
      this.showLoading = false;
      if (!this.exceedsResultLimit)
        this.traces.push(...data.Blobs);
    });
  }

  collapse(isCollapsed: boolean) {
    this.isCollapsed = isCollapsed;
  }

  nameFile() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hour = String(currentDate.getHours()).padStart(2, '0');
    const minute = String(currentDate.getMinutes()).padStart(2, '0');
    const second = String(currentDate.getSeconds()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}${hour}${minute}${second}`;
    return `Traces_${formattedDate}.zip`;
  }

  download(downloadFile: Array<string>) {
    let fileName = downloadFile[0];
    if (downloadFile.length > 1)
      fileName = this.nameFile();

    this.isDownloading = true;
    this._traceService.downloadTraceFile(downloadFile, fileName).subscribe((res: any) => {
      this.isDownloading = false;
      this.selectedTraces = [];
    });
  }

  delete(deleteFile: Array<string>) {
    this.showLoading = true;
    this.loadingMessage = this._i18nService.instant('TRACE.REMOVING_FILES');
    this.isDeleting = true;
    this._traceService.deleteFile(deleteFile).pipe(
      finalize(() => {
          this.showLoading = false;
          this.isDeleting = false;
      })
    ).subscribe({
      next: () => {
        this._showToastService.showToast(this._i18nService.instant('TRACE.REMOVED_FILES'), 'success');
        this.visuallyRemove(deleteFile);
      },
      complete: () => {
        this.showLoading = false;
        this.isDeleting = false;
      }
    });
  }

  visuallyRemove(deleteFile: Array<string>) {
    deleteFile.forEach(element => {
      const index = this.traces.findIndex((trace) => trace.Name === element);
      if (index !== -1)
        this.traces.splice(index, 1);
    });
  }

  showViewerDialog(trace: IBATraceFile) {
    this._modalService.open(DetailComponent, {
      closeOnBackdropClick: false,
      data: trace,
      width: '95%',
      height: '95%',
      maxWidth: 'none',
      maxHeight: 'none',
      closeOnRouterNavigation: true
    });
  }
}


